import React from 'react';
import styles from './CustomTitle.module.css';
import CustomTextMarkdown from '../customTextMarkdown/customTextMarkdown';

type CustomTitleType = {
    children: string;
    className?: any;
    isSubtitle?: boolean;
    center?: boolean;
}

const CustomTitle = (props: CustomTitleType) => {
    return (
        <CustomTextMarkdown
            className={`${props.className} ${props.isSubtitle ? styles.subtitle : styles.title}`}
            components={{ p : props.isSubtitle ? 'h4' : 'h2' }}
            style={{ textAlign : props.center ? 'center' : 'left' }}
        >
            {props.children}
        </CustomTextMarkdown>
    );
}

export default CustomTitle;